window.Blundstone = window.Blundstone || {};

window.Blundstone.breadcrumbsBack = function () {
  const buttons = document.querySelectorAll('[data-breadcrumbs-back]');

  // Nothing useful to step back to on a directly opened page
  if (window.history.length <= 1 || !document.referrer) {
    buttons.forEach((button) => button.setAttribute('hidden', ''));
    return;
  }

  buttons.forEach((button) => {
    button.addEventListener('click', () => window.history.back());
  });
};

// Remembers the collection the visitor browsed so the product breadcrumb can point back to it,
// without putting the collection in the product URL. Product pages keep the context (swatches,
// related products); every other page clears it, so search or homepage visits don't inherit it.
window.Blundstone.breadcrumbsContext = function () {
  const storageKey = 'blundstone:breadcrumbs-collection';
  const navs = document.querySelectorAll('.custom-breadcrumbs');
  const collectionNav = document.querySelector('[data-breadcrumbs-collection]');
  const productNav = document.querySelector('[data-breadcrumbs-product-collections]');

  try {
    if (collectionNav) {
      const { breadcrumbsCollection, breadcrumbsCollectionTitle, breadcrumbsCollectionUrl } = collectionNav.dataset;
      sessionStorage.setItem(
        storageKey,
        JSON.stringify({
          handle: breadcrumbsCollection,
          title: breadcrumbsCollectionTitle,
          url: breadcrumbsCollectionUrl,
        })
      );
      return;
    }

    if (!productNav) {
      sessionStorage.removeItem(storageKey);
      return;
    }

    const context = JSON.parse(sessionStorage.getItem(storageKey));
    if (!context || !context.handle || !context.url) return;

    // Only when the product really belongs to the remembered collection
    const productCollections = productNav.dataset.breadcrumbsProductCollections.split(',');
    if (!productCollections.includes(context.handle)) return;

    navs.forEach((nav) => {
      let parent = nav.querySelector('[data-breadcrumbs-parent]');
      if (!parent) {
        parent = document.createElement('li');
        parent.className = 'custom-breadcrumbs__item';
        parent.setAttribute('data-breadcrumbs-parent', '');
        parent.appendChild(document.createElement('a'));
        nav.querySelector('[aria-current="page"]').before(parent);
      }

      const link = parent.querySelector('a');
      link.href = context.url;
      link.textContent = context.title;
    });
  } catch (error) {
    // sessionStorage unavailable (private mode, blocked storage): keep the server-rendered trail
  }
};

window.Blundstone.initBreadcrumbs = function () {
  window.Blundstone.breadcrumbsBack();
  window.Blundstone.breadcrumbsContext();
};

// Cookiebot's auto-blocking can run this script after DOMContentLoaded has already fired
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', window.Blundstone.initBreadcrumbs);
} else {
  window.Blundstone.initBreadcrumbs();
}
